<template>
  <div class="bottomAdvertContainer" v-show="show">
    <img src="@/assets/img/components/browseTime/qixiaohang.png" alt="" />
    <div class="progress"><span :style="{ width: newPercent + '%' }"></span></div>
    <div class="time">
      <img src="@/assets/img/components/browseTime/bg.png" alt="" />
      <div>
        <p>{{ success ? '任务' : `浏览${getGetQueryValue('broswerTime')}秒` }}</p>
        <p>{{ success ? '浏览完成' : `获取${font}次数` }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reqAnnexNum,
  reqAnnexCap,
  reqBrowsedoneOne,
  reqChouqiandone,
  againplay,
  monographicnum,
  reqFlipDoneTaskUrl
} from '../../api/activity';
import { GetQueryValue } from '../../utils/tools';

export default {
  data() {
    return {
      timer: null,
      endTime: 0,
      success: false,
      show: false,
      font: '抽奖',
    };
  },
  computed: {
    newPercent() {
      const percent = (this.endTime / GetQueryValue('broswerTime')) * 100;
      return percent > 100 ? 100 : percent;
    },
  },
  watch: {
    $route() {
      this.getAnnexCap();
    },
  },
  mounted() {},
  methods: {
    getGetQueryValue(k) {
      return GetQueryValue(k);
    },
    // 浏览倒计时
    setIntervalTimer() {
      const broswerTimes = GetQueryValue('broswerTime');
      if (!this.show) return;
      this.clearIntervalTimer();
      this.timer = setInterval(() => {
        if (this.endTime < Number(broswerTimes)) {
          // eslint-disable-next-line no-plusplus
          this.endTime++;
        } else {
          this.endTime = Number(broswerTimes);
          this.success = true;
          this.getAnnexNum();
          this.clearIntervalTimer();
        }
      }, 1000);
    },
    clearIntervalTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    // 上报浏览状态
    async getAnnexNum() {
      const taskId = GetQueryValue('taskId');
      const type = GetQueryValue('activetype');
      const gameId = GetQueryValue('gameId');
      const jietu = GetQueryValue('jietu');
      const chouka = GetQueryValue('chouka');
      const gametitleType = GetQueryValue('gametitleType');
      if (taskId && type && Number(type) === 4) {
        await reqChouqiandone({ id: taskId, type });
      } else if (gameId) {
        let params = {
          whetherPlay: 0,
          titleType:gametitleType * 1,
        };
        await againplay(params);
      } else if (jietu) {
        await monographicnum(2);
      }else if(chouka){
        //翻卡活动
        await reqFlipDoneTaskUrl(type*1);
      } else {
        const { annexId, luckDrawId, linkId } = this;
        await reqAnnexNum(annexId, 2, linkId, luckDrawId);
      }
    },
    // 是否展示浏览活动
    async getAnnexCap() {
      // 两种类型，一种是配合抽奖，一种是配合挖矿
      const taskId = GetQueryValue('taskId');
      const type = GetQueryValue('activetype');
      const gameId = GetQueryValue('gameId');
      const jietu = GetQueryValue('jietu');
      const chouka = GetQueryValue('chouka');
      if ((taskId && type && Number(type) === 4) || gameId || jietu || chouka) {
        this.show = true;
        if (gameId) {
          this.font = '游戏';
        }
        this.setIntervalTimer();
      } else {
        this.annexId = GetQueryValue('annexId');
        this.luckDrawId = GetQueryValue('luckDrawId');
        this.linkId = GetQueryValue('linkId');
        const { annexId, luckDrawId, linkId } = this;
        this.show = false;
        if (!annexId || !luckDrawId || !linkId) return;

        const { code, data } = await reqAnnexCap(annexId, 2, luckDrawId);
        if (code === 0) {
          this.show = true;
          sessionStorage.setItem('back', true);
          if (data) {
            this.success = true;
            this.endTime = GetQueryValue('broswerTime');
          } else {
            this.setIntervalTimer();
          }
        }
      }
    },
  },
  beforeDestroy() {
    this.clearIntervalTimer();
  },
};
</script>

<style lang="scss" scoped>
.bottomAdvertContainer {
  position: fixed;
  top: 666px;
  right: 0;
  z-index: 9999;
  width: 160px;
  > img {
    position: relative;
    top: 8px;
    z-index: 10;
    display: block;
    width: 98px;
    margin: 0 auto;
  }
  .progress {
    position: relative;
    width: 160px;
    height: 14px;
    background: #e0e0e0;
    border-radius: 12px;
    > span {
      position: absolute;
      left: 0;
      display: inline-block;
      width: 100px;
      height: 14px;
      background: #ffe800;
      border-radius: 12px;
    }
  }
  .time {
    // width: 160px;
    // height: 74px;
    // text-align: center;
    position: relative;
    img {
      width: 160px;
    }
    > div {
      position: absolute;
      top: 8px;
      width: 100%;
      span {
        display: inline-block;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
      }
      p {
        padding-bottom: 4px;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        text-align: center;
      }
    }
  }
}
</style>
